import { render, staticRenderFns } from "./PrivateProducts.vue?vue&type=template&id=1a7e431a&scoped=true&"
import script from "./PrivateProducts.vue?vue&type=script&lang=js&"
export * from "./PrivateProducts.vue?vue&type=script&lang=js&"
import style0 from "./PrivateProducts.vue?vue&type=style&index=0&id=1a7e431a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7e431a",
  null
  
)

export default component.exports